import {useContext} from "react";
import DatatableContext, {DatatableContextData} from "./DatatableContext";

export default function useDatatableContext() : DatatableContextData {
    return useContext<DatatableContextData>(DatatableContext)
}
